import {Component, ElementRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {forkJoin} from 'rxjs';
import {OnBoardingDocsService} from './onBoardingDocs.service';

@Component({
  selector: 'onBoardingDocs-grid',
  templateUrl: './onBoardingDocs.component.html',
  providers: [OnBoardingDocsService],
})
export class OnBoardingDocsComponent extends BaseGridNoCookieComponent<OnBoardingDocsService> {
  fourEyes: boolean = false;
  fourEyesRequestId: string = '';
  foureyesComparisonId: number;
  differences: any;
  companyTypeList = [];
  getAssignedList = [];
  getRemaingList = [];
  selectedAssignedList = [];
  selectedRemaingList = [];
  docList = [];
  getRemainingParams = {};
  getAssigningParams = {};
  refernceTable: any;
  lkupTable: any;
  lkupCol: any;
  langId: any;
  selectedCompanyType: any;
  viewRole = this.securityService.isOtherStaff();
  tagName: string;
  isCollapsed: boolean = true;

  constructor(
    public gridService: OnBoardingDocsService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    elem: ElementRef
  ) {
    super(securityService, logger, visualsService, gridService, 'repLedgerDemands');
    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.loadVisuals();
    this.docList = this.visualsService.getLkpFromStorageAsJSON(
      'LKP_REGCMP_DOCUMENT_I_DOC_ID',
      true,
    );
    this.companyTypeList = this.visualsService.getLkpFromStorageAsJSON('LKP_LEGAL_FORM', true);
    let companyTpsContainColon =
      this.companyTypeList.filter((type) => {
        if (type.id.includes(':')) {
          return type;
        }
      }).length > 0;

    if (companyTpsContainColon) {
      this.companyTypeList = this.companyTypeList.filter((type) => {
        if (type.id.includes(':')) {
          return type;
        }
      });
    }

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.companyTypeList = this.visualsService.getLkpFromStorageAsJSON('LKP_LEGAL_FORM', true);
        let companyTpsContainColon =
          this.companyTypeList.filter((type) => {
            if (type.id.includes(':')) {
              return type;
            }
          }).length > 0;

        if (companyTpsContainColon) {
          this.companyTypeList = this.companyTypeList.filter((type) => {
            if (type.id.includes(':')) {
              return type;
            }
          });
        }
        this.docList = this.visualsService.getLkpFromStorageAsJSON(
          'LKP_REGCMP_DOCUMENT_I_DOC_ID',
          true,
        );
      },
    });
  }

  ngOnInit() {
    this.lkupCol = 'S_DOC_TYPE';
    this.lkupTable = 'REGCMP_DOCUMENT';
    this.refernceTable = 'CMP_DOC_MAP';
    this.selectedCompanyType = this.companyTypeList[0].id;
    this.langId = localStorage.getItem('langId');
    this.fourEyes? this.getFourEyesRequest() : this.refreshLists();
  }

  private getFourEyesRequest() {
    this.gridService.get4eyesRequest(this.fourEyesRequestId).subscribe({
      next: (data) => {
        this.differences = data.data.differences;
        this.loading = false;
        this.selectedCompanyType = data.data.entityId;
        this.getRemaingList = this.differences?.unassignedDocs?.rightValue.map(value => ({ id: value }));
        this.getAssignedList = this.differences?.assignedDocs?.rightValue.map(value => ({ id: value }));
        if(this.differences?.action?.rightValue == 'link'){
          this.selectedRemaingList = this.differences?.docTypeId?.rightValue;
        }else{
          this.selectedAssignedList = this.differences?.docTypeId?.rightValue;
        }
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  assign(id) {
    if (this.selectedRemaingList.includes(id)) {
      this.selectedRemaingList.splice(this.selectedRemaingList.indexOf(id), 1);
    } else {
      this.selectedRemaingList.push(id);
    }
  }
  unAssign(id) {
    if (this.selectedAssignedList.includes(id)) {
      this.selectedAssignedList.splice(this.selectedAssignedList.indexOf(id), 1);
    } else {
      this.selectedAssignedList.push(id);
    }
  }
  selectAllRemaining() {
    if (this.selectedRemaingList.length > 0) {
      this.selectedRemaingList = [];
    } else {
      this.selectedRemaingList = [];
      this.getRemaingList.forEach((data) => {
        this.selectedRemaingList.push(data.id);
      });
    }
  }
  selectAllAssigned() {
    if (this.selectedAssignedList.length > 0) {
      this.selectedAssignedList = [];
    } else {
      this.selectedAssignedList = [];
      this.getAssignedList.forEach((data) => {
        this.selectedAssignedList.push(data.id);
      });
    }
  }
  assignRequest() {
    if (this.selectedRemaingList.length > 0) {
      this.loading = true;
      let send = {
        cmpTypeId: this.selectedCompanyType,
        docTypeId: this.selectedRemaingList,
        lkupTable: this.refernceTable,
        lkupCol: this.lkupCol,
        action: 'link'
      };
      this.gridService.relate(send).subscribe({
        next: (data) => {
          this.selectedRemaingList = [];
          this.selectedAssignedList = [];
          this.refreshLists();
          LogService.emitAlert({
            type: 'success',
            body: data.message,
          });
        },
        error: (error) => {
          this.loading = false;
          this.logger.error(error);
        },
      });
    }
  }
  unAssignRequest() {
    if (this.selectedAssignedList.length > 0) {
      this.loading = true;

      let send = {
        cmpTypeId: this.selectedCompanyType,
        docTypeId: this.selectedAssignedList,
        lkupTable: this.refernceTable,
        lkupCol: this.lkupCol,
        action: 'unlink'
      };
      this.gridService.relate(send).subscribe({
        next: (data) => {
          this.selectedRemaingList = [];
          this.selectedAssignedList = [];
          this.refreshLists();
          LogService.emitAlert({
            type: 'success',
            body: data.message,
          });
        },
        error: (error) => {
          this.loading = false;
          this.logger.error(error);
        },
      });
    }
  }
  refreshLists() {
    this.loading = true;
    console.log(this.langId);
    this.getRemainingParams = {
      val: this.selectedCompanyType,
      lkupCol: this.lkupCol,
      lkupTable: this.lkupTable,
      referenceTable: this.refernceTable,
      langId: this.langId,
    };

    this.getAssigningParams = {
      val: this.selectedCompanyType,
      lkupCol: this.lkupCol,
      lkupTable: this.lkupTable,
      referenceTable: this.refernceTable,
      langId: this.langId,
    };

    forkJoin([
      this.gridService.getRemaining(this.getRemainingParams),
      this.gridService.getAssigned(this.getAssigningParams),
    ]).subscribe({
      next: ([remaingList, assignedList]) => {
        this.getRemaingList = remaingList.data;
        this.getAssignedList = assignedList.data;

        this.loading = false;
      },
    }),
      (error) => {
        this.logger.error(error);
        this.loading = false;
      };
  }
}
